<div class="header">
  @if (!expanded()) {
    <button class="flat-btn nav-btn icon-expand material-icons" (click)="expand()">menu</button>
  } @else {
    <button class="flat-btn nav-btn icon-close material-icons" (click)="collapse()">close</button>
  }
  <div class="company-info">
    <a class="flat-btn" routerLink="/"
      >{{ 'CORE.COMPONENTS.HEADER.BOTTOM.COMPANY-NAME.LINK-TEXT' | translate | hyphenate }}
    </a>
    <img src="/images/svg/AT_logo.svg" alt="logo" width="35" height="35" />
  </div>
</div>
@if (expanded()) {
  <div class="side-bar-menu">
    <div class="top-block">
      <a (click)="navigate()" (keydown.enter)="navigate()" [routerLink]="['support']" class="link-btn">{{
        'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-1' | translate
      }}</a>
      <a (click)="navigate()" (keydown.enter)="navigate()" [routerLink]="['news']" class="link-btn"
        >{{ 'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-2' | translate }}
      </a>
      <a [href]="loginUrl" class="link-btn">
        {{ 'CORE.COMPONENTS.HEADER.BOTTOM.NAVIGATION.LINKS.LINK-3' | translate }}
      </a>
    </div>
    <div class="bottom-block">
      <a class="link-btn" (click)="navigate()" [routerLink]="['system-messages']"
        >{{ 'CORE.COMPONENTS.HEADER.TOP.SYSTEM-MESSAGES.BTN-TEXT' | translate | hyphenate }}
      </a>
      <div class="language-control-wrapper mobile">
        <button [matMenuTriggerFor]="menu" class="lang-menu-btn">
          <div lang="en">Language</div>
          <div class="material-icons arrow-icon" aria-hidden="true">arrow_drop_down</div>
        </button>
        <mat-menu #menu="matMenu">
          @for (entry of languages | keyvalue; track entry) {
            <button
              mat-menu-item
              class="lang-menu-item"
              (click)="onChangeLang(entry.key)"
              [class]="{ 'selected-lang': selectedLang === entry.key }"
            >
              <div class="name">
                {{ entry.value }}
                @if (selectedLang === entry.key) {
                  <div class="material-icons checked-icon">done</div>
                }
              </div>
            </button>
          }
        </mat-menu>
      </div>
    </div>
  </div>
}
